import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { InstallApp } from "@/components/InstallApp";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import ReferralDetail from "@/pages/ReferralDetail";
import Admin from "@/pages/Admin";
import Brand from "@/pages/Brand";
import Contatti from "@/pages/Contatti";
import VerifyEmail from "@/pages/VerifyEmail";
import CompleteProfile from "@/pages/CompleteProfile";
import CompanyArea from "@/pages/CompanyArea";

function AppRouter() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/accedi" element={<Login />} />
        <Route path="/registrati" element={<Register />} />
        <Route path="/registrati/azienda" element={<Register />} />
        <Route path="/verifica-email" element={<VerifyEmail />} />
        <Route path="/completa-profilo" element={<ProtectedRoute role="user" allowIncomplete><CompleteProfile /></ProtectedRoute>} />
        <Route path="/azienda" element={<ProtectedRoute role="company"><CompanyArea /></ProtectedRoute>} />
        <Route path="/password-dimenticata" element={<ForgotPassword />} />
        <Route path="/reimposta-password" element={<ResetPassword />} />
        <Route path="/brand" element={<Brand />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/dashboard" element={<ProtectedRoute role="user"><Dashboard /></ProtectedRoute>} />
        <Route path="/segnalazioni/:id" element={<ProtectedRoute role="user"><ReferralDetail /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors />
        <InstallApp />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
